<header>
  <mat-toolbar style="background-color:#5775a8; min-height: 100px; max-height: 100px">
    <div class="flex flex-row w-full items-center">
      <div class="flex justify-center">
        <a href="http://www.oregon.gov/oha/ph/pages/index.aspx" target="_blank" title="Oregon Health Authority">
          <img src="../../../assets/images/OHA-Black.png" style="width: 198px; height: 75px;"
            alt="Indoor Clean Air Act - Tobacco Prevention and Education Program" />
        </a>

        <div class="flex items-center">
          <span class="p-l-16">
            <a href="http://public.health.oregon.gov/PreventionWellness/TobaccoPrevention/SmokefreeWorkplaceLaw/Pages/index.aspx"
              target="_blank" class="navbar-brand" title="Oregon's Indoor Clean Air Act" style="color: white;">
              Indoor Clean Air Act
              <br>
              Tobacco Prevention and Education Program
            </a>
          </span>
        </div>
      </div>

    </div>
  </mat-toolbar>
</header>
<div class="flex justify-center pt-4" role=“main”>
  <div class="w-9/12 column flex flex-col matero-content-wrap">
    <div class="flex flex-row justify-start items-center gap-4">
      <span>
        <h1 class="text-lg font-semibold">{{"accessibility.title" | translate}}</h1>
      </span>
      <app-translate class="ml-auto"></app-translate>
    </div>

    <div class="rounded-lg p-8" style="border: 1px solid black;">

      <div class="flex flex-row items-start justify-between">
        <div class="flex flex-col gap-4">
          <p>{{"accessibility.text1" | translate}}</p>

        </div>
        <div class="flex items-center">
        <mat-icon class="ml-4" style="font-size: 36px; width: 36px; height: 36px; border: 2px solid black; border-radius: 50%; padding: 16px; display: flex; align-items: center; justify-content: center;">accessibility</mat-icon>
        </div>
      </div>
      <br />
      <hr style="border-top: 1px solid #000;" />
      <br />
      {{"accessibility.wcag" | translate}}
      <br />
      <br />
      {{"accessibility.text2" | translate}} <a
        href="mailto:More.FreshAir@odhsoha.oregon.gov">{{"accessibility.emailAddress" | translate}}</a>
      <br />
      <br />
    </div>
  </div>
</div>

<br />
<mat-toolbar class="mt-10 w-full fixed bottom-0" style="min-height: 40px; max-height: 40px;">
  <div class="absolute right-10">
    <span class="f-s-12 p-r-16">Oregon Health Authority</span>
    <a class="f-s-12 p-r-16" href="http://public.health.oregon.gov/PreventionWellness/TobaccoPrevention/SmokefreeWorkplaceLaw/Pages/index.aspx" target="_blank" rel="noreferrer noopener">
      Indoor Clean Air Act
    </a>
    <span class="f-s-12">
      {{environment.build}} Version {{environment.version}}
    </span>
 </div>
</mat-toolbar>
<!-- <app-footer class="w-full fixed bottom-0"></app-footer> -->